import moment from 'moment';
import api from '../../constants/api';
import { HEADERS } from '../../constants/headers';

/**
 * Will send the score to warbox server
 *
 * @param {*} values
 * @param {*} token
 * @return {*}
 */
export const sendScoreToWarbox = async (values, token, callback) => {
    const {
        currentRFC,
        primerNombre,
        segundoNombre,
        apellidoPaterno,
        apellidoMaterno,
        email,
        fechaNacimiento,
        delegacionMunicipio,
        estado,
        cp,
        ciudad,
        direccion1,
        coloniaPoblacion,
        signature,
    } = values;

    const leadValues = {
        creditBureau: {
            RFC: currentRFC,
            name: primerNombre,
            middleName: segundoNombre,
            firstLastName: apellidoPaterno,
            secondLastName: apellidoMaterno,
            confirmationDate: moment().format(),
            email,
            birthdate: fechaNacimiento,
            address: {
                municipality: delegacionMunicipio,
                city: ciudad,
                state: estado,
                zipCode: cp,
                address: direccion1,
                colony: coloniaPoblacion,
            },
            sign: signature,
            isConfirmed: true,
        },
    };

    try {
        const response = await api.post(
            `/leads/buro/${token}`,
            leadValues,
            HEADERS()
        );

        const { data } = response;

        callback({
            success: true,
            data,
        });
    } catch (error) {
        callback({
            success: false,
            error: error.response.data,
        });
    }
};
